<template>
  <div>
    <div class="caption pb-1" style="color:#757575">
      {{ titleName + ' : ' + name }}
    </div>
    <div class="caption pb-1" style="color:#757575">
      {{ titleRef1 + ' : ' + ref1 }}
    </div>
    <v-layout class="caption pb-3" style="color:#757575">
      <!-- <v-flex xs6>{{ titleDocNo + ' : ' + docNo }}</v-flex> -->
      <v-flex xs6>{{ 'Document No. : ' + docNo }}</v-flex>
      <v-flex xs6 text-xs-right>{{ docDateTime }}</v-flex>
    </v-layout>
    <v-divider class="pb-3"></v-divider>

    <div class="caption pb-1" style="color:#373A3C" v-html="invoice"></div>

    <!--    <div v-if="splited">-->
    <div>
      <v-layout pb-2>
        <v-flex xs6 class="body-1" style="color:#373A3C">
          {{ text.total }}
        </v-flex>
        <v-flex xs6 class="subheading" style="color:#0270BA" text-xs-right>
          {{ total | currency }}
        </v-flex>
      </v-layout>
      <v-layout pb-2>
        <v-flex xs6 class="body-1" style="color:#373A3C">
          {{ text.paid }}
        </v-flex>
        <v-flex xs6 class="subheading" style="color:#0270BA" text-xs-right>
          {{ paid | currency }}
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    splited: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    total() {
      return this.$store.state.total
    },
    paid() {
      return this.$store.state.paid
    },
    titleName() {
      return this.$options.filters.dbTextDisplay('CustName')
    },
    name() {
      return this.$store.state.name
    },
    titleDocNo() {
      return this.$options.filters.dbTextDisplay('DocumentNo')
    },
    docNo() {
      return this.$store.state.docNo
    },
    docDateTime() {
      if (this.$store.state.language == 'EN') {
        return this.$store.state.docDateTimeEn
      } else {
        return this.$store.state.docDateTimeTh
      }
    },
    titleRef1() {
      return this.$options.filters.dbTextDisplay('Ref1')
    },
    ref1() {
      return this.$store.state.ref1
    },
    invoice() {
      let html = ''
      let data = null
      if (this.$store.state.invoicedesc) {
        data = this.$store.state.invoicedesc
        html = this.recursiveInvoiceItems(data, -1)
      }
      return html
    },
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          total: 'Total',
          paid: 'Paid'
        }
      } else {
        obj = {
          total: 'ยอดรวม',
          paid: 'ชำระแล้ว'
        }
      }
      return obj
    }
  },
  methods: {
    recursiveInvoiceItems(data, padding) {
      let html = ''
      let pad = (padding + 1) * 8
      data.forEach(item => {
        html += `<div class="d-inline-block pb-1" style="width:70%;padding-left: ${pad}px"> ${
          item.description_th
        } </div>`
        if (item.subdesc && item.subdesc.length > 0) {
          html += `<div class="d-inline-block" style="text-align: right;width:30%"></div>`
          html += this.recursiveInvoiceItems(item.subdesc, padding + 1)
        } else {
          html += `<div class="d-inline-block" style="text-align: right;width:30%"> ${this.$options.filters.currency(
            item.price
          )} </div>`
        }
      })
      // description_th
      // discount
      return html
    }
  }
}
</script>
